import {
  AUDIT_LOG_API,
  CUSTOMER_API,
  FORMS_API,
  SERVICE_REQUEST_API,
  TECHNICIAN_API,
} from '@shared/constants/api.constants';
import { OfflineEndpointPolicyType } from '@shared/constants/offline.constants';

export type OfflineEndpointKey =
  | 'SERVICE_REQUEST_DETAILS'
  | 'SERVICE_REQUEST_SEARCH'
  | 'ADD_FORM_RESPONSE'
  | 'UPDATE_FORM_RESPONSE'
  | 'SERVICE_REQUEST_FORM_PLACEMENT'
  | 'SERVICE_REQUEST_FORM_OFFLINE_CONTEXT'
  | 'SERVICE_REQUEST_FORM_SCHEDULED_TECHNICIANS'
  | 'SERVICE_REQUEST_FORM_OFFLINE_SUBMISSIONS'
  | 'CUSTOMER_DETAILS'
  | 'TECHNICIAN_PROFILE'
  | 'TECHNICIAN_DASHBOARD'
  | 'TECHNICIAN_FORMS_SEARCH'
  | 'TECHNICIAN_SCHEDULE'
  | 'TECHNICIAN_SCHEDULE_EVENTS'
  | 'TECHNICIAN_COMPETENCIES_SEARCH'
  | 'TECHNICIAN_UPDATE_LOGS_SEARCH'
  | 'TECHNICIAN_ROSTER_SEARCH';

export interface OfflineEndpointPolicyEntry {
  key: OfflineEndpointKey;
  url: string;
  policy: OfflineEndpointPolicyType;
  module: 'service';
}

/** Service-module endpoint offline policies. */
export const OFFLINE_ENDPOINT_POLICIES: OfflineEndpointPolicyEntry[] = [
  {
    key: 'SERVICE_REQUEST_DETAILS',
    url: SERVICE_REQUEST_API.SERVICE_REQUEST_DETAILS,
    policy: 'cache-read',
    module: 'service',
  },
  {
    key: 'SERVICE_REQUEST_SEARCH',
    url: SERVICE_REQUEST_API.SERVICE_REQUEST_SEARCH,
    policy: 'cache-read',
    module: 'service',
  },
  {
    key: 'SERVICE_REQUEST_FORM_PLACEMENT',
    url: SERVICE_REQUEST_API.SERVICE_REQUEST_FORM_PLACEMENT,
    policy: 'cache-read',
    module: 'service',
  },
  {
    key: 'ADD_FORM_RESPONSE',
    url: FORMS_API.ADD_FORM_RESPONSE,
    policy: 'queue-write',
    module: 'service',
  },
  {
    key: 'UPDATE_FORM_RESPONSE',
    url: FORMS_API.UPDATE_FORM_RESPONSE,
    policy: 'queue-write',
    module: 'service',
  },
  {
    key: 'SERVICE_REQUEST_FORM_OFFLINE_CONTEXT',
    url: SERVICE_REQUEST_API.SERVICE_REQUEST_FORM_OFFLINE_CONTEXT,
    policy: 'cache-read',
    module: 'service',
  },
  {
    key: 'SERVICE_REQUEST_FORM_SCHEDULED_TECHNICIANS',
    url: SERVICE_REQUEST_API.SERVICE_REQUEST_FORM_SCHEDULED_TECHNICIANS,
    policy: 'cache-read',
    module: 'service',
  },
  {
    key: 'SERVICE_REQUEST_FORM_OFFLINE_SUBMISSIONS',
    url: SERVICE_REQUEST_API.SERVICE_REQUEST_FORM_OFFLINE_SUBMISSIONS,
    policy: 'cache-read',
    module: 'service',
  },
  {
    key: 'CUSTOMER_DETAILS',
    url: CUSTOMER_API.DETAILS,
    policy: 'cache-read',
    module: 'service',
  },
  {
    key: 'TECHNICIAN_PROFILE',
    url: TECHNICIAN_API.PROFILE,
    policy: 'cache-read',
    module: 'service',
  },
  {
    key: 'TECHNICIAN_DASHBOARD',
    url: TECHNICIAN_API.DASHBOARD,
    policy: 'cache-read',
    module: 'service',
  },
  {
    key: 'TECHNICIAN_FORMS_SEARCH',
    url: TECHNICIAN_API.FORMS,
    policy: 'cache-read',
    module: 'service',
  },
  {
    key: 'TECHNICIAN_SCHEDULE',
    url: TECHNICIAN_API.SCHEDULE,
    policy: 'cache-read',
    module: 'service',
  },
  {
    key: 'TECHNICIAN_SCHEDULE_EVENTS',
    url: TECHNICIAN_API.CALENDAR,
    policy: 'cache-read',
    module: 'service',
  },
  {
    key: 'TECHNICIAN_COMPETENCIES_SEARCH',
    url: TECHNICIAN_API.PROFILE,
    policy: 'cache-read',
    module: 'service',
  },
  {
    key: 'TECHNICIAN_UPDATE_LOGS_SEARCH',
    url: AUDIT_LOG_API.LIST,
    policy: 'cache-read',
    module: 'service',
  },
  {
    key: 'TECHNICIAN_ROSTER_SEARCH',
    url: TECHNICIAN_API.LIST,
    policy: 'cache-read',
    module: 'service',
  },
];
